import { configureStore } from '@reduxjs/toolkit';
import claimReducer from './claimSlice';

export const store = configureStore({
  reducer: {
    claim: claimReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 